var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embeds h-wrapper"},[_c('div',{staticClass:"embeds-inner"},_vm._l((_vm.htmlEmbed),function(item,index){return _c('div',{key:("html-block-" + index),domProps:{"innerHTML":_vm._s(item.content)}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }